import { render, staticRenderFns } from "./ChipCardShirt.vue?vue&type=template&id=32745c40&"
import script from "./ChipCardShirt.vue?vue&type=script&lang=js&"
export * from "./ChipCardShirt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports